import React from 'react';
import { Dialog } from 'primereact/dialog';
import { PickList } from 'primereact/picklist';
import { Button } from 'primereact/button';
import { configuracoesEstiloBtnAcao } from './helpers/configuracoesEstiloBtnAcao';
import { ProgressSpinner } from 'primereact/progressspinner';

export default function Vincular({
    acao = 'Salvar',
    iconeBotaoAcao = 'cadastro',
    idParaPostDelete,
    onSubmitBotaoAcao,
    openModal,
    setOpenModal,
    titleModal,
    fonteTitulo,
    alvoTitulo,
    fonteDados = [],
    setFonte,
    alvoDados,
    setAlvo,
    isFetching = false
}) {
    const footer = (
        <div>
            <Button
                disabled={isFetching}
                label={acao}
                className={configuracoesEstiloBtnAcao[iconeBotaoAcao].cssClass}
                icon={configuracoesEstiloBtnAcao[iconeBotaoAcao].icon}
                onClick={onSubmitBotaoAcao.bind(this, idParaPostDelete, fonteDados, alvoDados)} />
            <Button
                disabled={isFetching}
                label="Cancelar"
                className='p-button-secondary' icon="pi pi-times" onClick={setOpenModal.bind(this, false)} />
        </div>
    );
    const onChange = event => {
        setFonte(event.source);
        setAlvo(event.target);
    };

    const template = src => (        
        <div className="p-clearfix">
            <div style={{
                fontSize: '14px',
                margin: '15px 5px 0 0'
            }}>{src.idGrupo || src.id} - {src?.ZeloTvGrupo?.nome || src.nome}</div>
        </div>
    );

    return (
        <Dialog
            style={{ width: '70vw' }}
            footer={footer} header={titleModal} visible={openModal} onHide={setOpenModal.bind(this, false)} >
            {isFetching && <ProgressSpinner />}
            {!isFetching && <PickList sourceStyle={{
                height: '25vh',
                width: '25vw'
            }} targetStyle={{
                height: '25vh',
                width: '25vw'
            }} onChange={onChange}
            source={fonteDados}
            target={alvoDados} sourceHeader={fonteTitulo} itemTemplate={template} targetHeader={alvoTitulo} />}
        </Dialog>
    );
}
